export default __webpack_public_path__ + "static/media/vietnam_powerline_transmission.26ad2b3f.png";